import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { useAuthStore } from "@/store/authStore";

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, isAdmin, loading } = useAuthStore();
  const location = useLocation();

  if (loading) {
    return (
      <div className="text-muted-foreground flex min-h-screen items-center justify-center text-sm">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!isAdmin()) {
    // Send to /login — that page renders a "not an admin" message when
    // signed in without the admin role, with a sign-out button.
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
